import React from 'react';
import { useSelector } from 'react-redux';
import { Flex } from '@adobe/react-spectrum';
import { View } from '@react-spectrum/view';
import { getPagesIds } from 'app/stores/selectors';
import { Slide } from './slide/Slide';
const PagePreview = (props) => {
    const { slideId } = props;
    return (React.createElement(View, { width: "size-1250", height: "auto", backgroundColor: "gray-200", padding: "size-50", margin: "size-50" },
        React.createElement(Slide, { slideId: slideId, keepAspectRatio: true })));
};
export const Slides = () => {
    const slides = useSelector((state) => getPagesIds(state));
    return (React.createElement(View, { UNSAFE_className: "slides slides-list", paddingY: "size-25", backgroundColor: "gray-75", overflow: "hidden scroll" },
        React.createElement(Flex, { width: "100%", minHeight: "100%", maxHeight: "size-400", direction: "column", gap: "size-100" }, slides.map(slideId => (React.createElement(PagePreview, { key: slideId, slideId: slideId }))))));
};
